(function () {
  'use strict';

  if (window.AxiomFooterReveal) return;

  // The whole footer group (Footer + Footer bottom panel) slides up from behind
  // the page content at half the scroll speed. section-footer.css applies the
  // offset only when the Footer section's reveal setting is on, on desktop.
  var SHELL_SELECTOR = '.footer-group-shell';
  var ENABLED_SELECTOR = '.footer[data-footer-reveal-enabled="true"]';
  var PARALLAX_RATIO = 0.5;
  var desktopQuery = window.matchMedia('(min-width: 768px)');
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var frame = null;

  function update() {
    frame = null;
    var shell = document.querySelector(SHELL_SELECTOR);
    if (!shell) return;

    if (!desktopQuery.matches || reducedMotionQuery.matches || !shell.querySelector(ENABLED_SELECTOR)) {
      shell.style.removeProperty('--footer-reveal-offset');
      return;
    }

    // offsetTop/offsetHeight ignore transforms, so the offset never feeds back into itself.
    var height = shell.offsetHeight;
    var naturalBottom = shell.offsetTop + height - window.scrollY;
    var remaining = Math.min(Math.max(naturalBottom - window.innerHeight, 0), height);
    shell.style.setProperty('--footer-reveal-offset', (-remaining * PARALLAX_RATIO) + 'px');
  }

  function requestUpdate() {
    if (frame === null) frame = window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  window.addEventListener('load', requestUpdate);
  desktopQuery.addEventListener('change', requestUpdate);
  reducedMotionQuery.addEventListener('change', requestUpdate);
  document.addEventListener('shopify:section:load', requestUpdate);
  document.addEventListener('shopify:section:unload', requestUpdate);

  if ('ResizeObserver' in window) {
    var resizeObserver = new ResizeObserver(requestUpdate);
    var shell = document.querySelector(SHELL_SELECTOR);
    var main = document.getElementById('main-content');
    if (shell) resizeObserver.observe(shell);
    if (main) resizeObserver.observe(main);
  }

  requestUpdate();

  window.AxiomFooterReveal = { update: requestUpdate };
})();
